import classNames from "classnames";
import { ConnectedMediaUploadForm } from "fleet/controller/media-library/connected-media-upload-form";
import DraggableContentList from "fleet/view/strategy/draggable-content-list.js";
import PropTypes from "prop-types";
import React from "react";
import {
  Badge,
  Button,
  Col,
  FormLabel,
  FormControl,
  FormGroup,
  Row,
} from "react-bootstrap";
import { Table, Column } from "ui/table/index.js";
import { formatTags } from "util/table-format";

class ContentGroupCreateForm extends React.Component {
  static get displayName() {
    return "ContentGroupCreateForm";
  }

  static get propTypes() {
    return {
      onChangeName: PropTypes.func.isRequired,
      onUpdateContent: PropTypes.func.isRequired,
      contentGroupName: PropTypes.string,
      selectedContent: PropTypes.array,
      userContents: PropTypes.array,
    };
  }

  static get defaultProps() {
    return {
      contentGroupName: "",
      selectedContent: [],
      userContents: [],
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      mode: "select",
    };

    this._updateContent = this._updateContent.bind(this);
    this._updateName = this._updateName.bind(this);

    this.addContent = this._updateContent.bind(this, "add");
    this.deleteContent = this._updateContent.bind(this, "delete");
    this.editDuration = this.editDuration.bind(this);
    this.replaceContent = this._updateContent.bind(this, "replaceAll");
    this.selectAll = this.selectAll.bind(this);
  }

  _onCreateOptionChange(option) {
    this.setState({ mode: option });
  }

  _formatPreview(url, row) {
    let content;
    if (row.type.startsWith("video")) {
      content = <i className="fa fa-2x fa-video-camera"></i>;
    } else if (row.type.startsWith("image")) {
      content = <img src={url} />;
    }
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="user-content-preview"
      >
        {content}
      </a>
    );
  }

  _updateName(e) {
    const name = e.currentTarget.value;
    this.props.onChangeName(name);
  }

  _updateContent(mode, updatedContent = []) {
    const content = Array.isArray(updatedContent)
      ? updatedContent
      : [updatedContent];

    let selected = [...this.props.selectedContent];
    const contentIds = content.map((c) => c.id);

    switch (mode) {
      case "add":
        selected = selected.concat(
          content.filter((c) => {
            return !selected.find((s) => s.id === c.id);
          }),
        );
        break;
      case "replaceAll":
        selected = content;
        break;
      case "edit":
        content.forEach((c) => {
          const idx = selected.findIndex((s) => s.id === c.id);
          selected[idx] = c;
        });
        break;
      case "delete":
        selected = selected.filter((c) => {
          return contentIds.indexOf(c.id) < 0;
        });
        break;
      default:
        break;
    }

    this.props.onUpdateContent(selected);
  }

  selectAll(isSelected, content) {
    const selected = isSelected ? content : [];
    this.replaceContent(selected);
  }

  editDuration(duration, content) {
    this._updateContent("edit", { ...content, duration });
  }

  _renderContentTable() {
    const { selectedContent, userContents } = this.props;
    const selected = selectedContent.map((c) => c.id);
    const LabelTag = <Badge variant="danger" />;
    return (
      <Row>
        <Col xs={12}>
          <Table
            data={userContents}
            condensed={true}
            hover={true}
            options={{ sizePerPage: 3, hideSizePerPage: true }}
            pagination={true}
            search={true}
            selectRow={{
              selected,
              mode: "checkbox",
              onSelect: this.addContent,
              onSelectAll: this.selectAll,
            }}
          >
            <Column key="id" dataField="id" isKey={true} hidden={true}>
              Id
            </Column>
            <Column key="name" dataField="name" dataSort={true}>
              Name
            </Column>
            <Column key="type" dataField="type" dataSort={true}>
              Type
            </Column>
            <Column
              key="tag"
              dataField="tag"
              dataSort={true}
              dataFormat={formatTags.bind(null, LabelTag)}
            >
              Creative Category
            </Column>
            <Column
              key="url"
              dataField="url"
              dataAlign="center"
              dataFormat={this._formatPreview}
            >
              Preview
            </Column>
          </Table>
        </Col>
      </Row>
    );
  }

  render() {
    const { contentGroupName, selectedContent } = this.props;
    const { mode } = this.state;
    return (
      <div className="create-content-group-form">
        <Row>
          <Col xs={4}>
            <FormGroup controlId="contentGroupName">
              <FormLabel>Media Group Name</FormLabel>
              <FormControl
                type="text"
                key="name"
                name="name"
                value={contentGroupName || ""}
                onChange={this._updateName}
              />
            </FormGroup>
          </Col>
          <Col xs={8}>
            <DraggableContentList
              items={selectedContent}
              onReorderContent={this.replaceContent}
              onDeleteContent={this.deleteContent}
              onChangeContentDuration={this.editDuration}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Button
              className="btn btn-outline btn-content-group-toggle"
              onClick={() => this._onCreateOptionChange("upload")}
            >
              <i
                className={classNames("fa", "fa-lg", {
                  "fa-caret-right": mode !== "upload",
                  "fa-caret-down": mode === "upload",
                })}
              />
              Upload Content
            </Button>
          </Col>
        </Row>
        {mode === "upload" && <ConnectedMediaUploadForm />}
        <Row>
          <Col xs={4}>
            <Button
              className="btn btn-outline btn-content-group-toggle"
              onClick={() => this._onCreateOptionChange("select")}
            >
              <i
                className={classNames("fa", "fa-lg", {
                  "fa-caret-right": mode !== "select",
                  "fa-caret-down": mode === "select",
                })}
              />
              Select From Existing Content
            </Button>
          </Col>
        </Row>
        {mode === "select" && (
          <Row>
            <Col xs={12}>{this._renderContentTable()}</Col>
          </Row>
        )}
      </div>
    );
  }
}

export { ContentGroupCreateForm };
